import React, { useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  makeStyles,
  MenuItem,
  Paper,
  Select,
  Snackbar,
  TextField,
  Typography,
} from "@material-ui/core";
import instance from "api/globalaxios";
import MuiAlert from "@material-ui/lab/Alert";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: "1.5rem 3rem",
    borderRadius: "8px",
    cursor: "pointer",
  },
  paper2: {
    padding: "1.5rem 3rem",
    borderRadius: "8px",
  },
  headingNew: {
    fontSize: "16px",
    lineHeight: "36px",
    display: "flex",
    alignItems: "center",
    texttransform: "capitalize",
    color: "#4F4F4F",
  },
  bigbtn: {
    fontWeight: "bold",
    fontSize: "24px",
    lineHeight: "36px",
    color: "#FFFFFF",
    textTransform: "none",
    [theme.breakpoints.down("sm")]: {
      fontSize: "16px",
    },
  },
  helperText: {
    fontSize: "14px",
    lineHeight: "20px",
    color: "#4F4F4F",
  },
}));

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const GenerateInvoice = ({ opened, profile, registeredDisputesList }) => {
  const classes = useStyles();

  const [expand, setExpand] = useState(opened);
  const [invoiceType, setInvoiceType] = useState("");
  const [registeredDispute, setregisteredDispute] = useState("");
  const [party, setParty] = useState("");
  const [partyList, setPartyList] = useState([]);
  const [currency, setCurrency] = useState("");
  const [costAmount, setCostAmount] = useState("");
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedDispute, setSelectedDispute] = useState();

  const [openSnackBar1, setOpenSnackBar1] = React.useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const handleCloseSnackBar1 = () => {
    setOpenSnackBar1(false);
  };

  const [openSnackBar2, setOpenSnackBar2] = useState(false);
  const handleCloseSnackBar2 = () => {
    setOpenSnackBar2(false);
  };

  const [openSnackBar3, setOpenSnackBar3] = useState(false);
  const handleCloseSnackBar3 = () => {
    setOpenSnackBar3(false);
  };

  const [openSnackBar4, setOpenSnackBar4] = useState(false);
  const handleCloseSnackBar4 = () => {
    setOpenSnackBar4(false);
  };

  const invoiceTypeList = [
    {
      toShow: "Provision for Conciliation Invoices (Pro Forma)",
      toSend: "conciliation_proforma",
    },
    {
      toShow: "Arbitrator Invoices (Pro Forma)",
      toSend: "arbitrator_proforma",
    },
    {
      toShow: "Stamp Papers",
      toSend: "stamp_paper",
    },
  ];

  const currencyList = [
    {
      toShow: "Rs",
      toSend: "INR",
    },
  ];

  const onRegisterDisputeChange = (e) => {
    setregisteredDispute(e.target.value);
    setLoading(true);
    setParty("");
    setPartyList([]);
    const dispute = registeredDisputesList.find(
      (dispute) => dispute.tiac_custom_dispute_id === e.target.value
    );
    setSelectedDispute(dispute);
    const parties = [];
    getDisputeDetails(dispute.id)
      .then((res) => {
        res.data.dispute_data.claimant.forEach((profile) => {
          const name = `${profile.user.first_name} ${profile.user.last_name}`;
          const id = profile.user.id;
          parties.push({ name, id });
        });
        res.data.dispute_data.respondent.forEach((profile) => {
          const name = `${profile.user.first_name} ${profile.user.last_name}`;
          const id = profile.user.id;
          parties.push({ name, id });
        });
        setPartyList(parties);
        setLoading(false);
      })
      .catch(() => {
        setPartyList(parties);
        setLoading(false);
      });
  };
  const onInvoiceTypeChange = (e) => {
    setInvoiceType(e.target.value);
  };
  const onPartyChange = (e) => {
    setParty(e.target.value);
  };
  const onCurrencyChange = (e) => {
    setCurrency(e.target.value);
  };
  const onCostAmountChange = (e) => {
    setCostAmount(e.target.value);
  };
  const onDescriptionChange = (e) => {
    setDescription(e.target.value);
  };

  const digitsAfterDecimalPoint = (number) => {
    number = parseInt(number);
    if (Number.isInteger(number)) {
      return 0;
    } else {
      return number.toString().split(".")[1].length;
    }
  };

  const onSubmit = () => {
    if (
      !invoiceType ||
      !registeredDispute ||
      !party ||
      !currency ||
      !costAmount ||
      costAmount.trim() == "" ||
      description.trim() == ""
    ) {
      setOpenSnackBar3(true);
    } else {
      if (digitsAfterDecimalPoint(costAmount) > 2) {
        setOpenSnackBar4(true);
      } else {
        setLoading(true); // Disable button
        
        const mii = selectedDispute?.description;
        const stage =
          selectedDispute?.flow_type === "mediation"
            ? "conciliation"
            : "arbitration";
        let data = {
          amount: costAmount,
          description: description,
          disputeId: registeredDispute,
          userid: party,
          stage: stage,
          mii: mii,
          invoice_type: invoiceType,
        };
        sendInvoiceSebi(data)
          .then((res) => {
            setInvoiceType("");
            setregisteredDispute("");
            setParty("");
            setPartyList([]);
            setCurrency("");
            setCostAmount("");
            setDescription("");
            setOpenSnackBar2(true);
          })
          .catch((error) => {
            const errorData = error?.response?.data;
            setErrorMessage(
              errorData?.user?.email?.[0] ||
                errorData?.phone_number?.[0] ||
                errorData?.error ||
                errorData?.message ||
                "Failed to generate invoice. Please try again."
            );
            setOpenSnackBar1(true);
          })
          .finally(() => {
            setLoading(false);
          });
      }
    }
  };

  return (
    <div id="paymentFrm" className="container">
      <Grid container justify="center" direction="row">
        <Grid item md={7} sm={9} xs={11}>
          <Paper
            className={expand ? classes.paper2 : classes.paper}
            onClick={() => {
              setExpand(true);
            }}
          >
            <Grid container justify="flex-start">
              <Grid item>
                <Typography className={classes.headingNew}>
                  Generate Invoice
                </Typography>
              </Grid>
            </Grid>
            {expand && (
              <>
                <Box height="1rem"></Box>
                <Grid container spacing={3}>
                  <Grid item sm={12} xs={12}>
                    <FormControl required fullWidth={true} variant="outlined">
                      <InputLabel id="invoice_type">Select type</InputLabel>
                      <Select
                        id="invoice_type"
                        name="invoice_type"
                        value={invoiceType}
                        onChange={onInvoiceTypeChange}
                        label="Select type *"
                        IconComponent={() => (
                          <FontAwesomeIcon
                            icon={faChevronDown}
                            style={{ marginRight: "8px" }}
                          />
                        )}
                      >
                        {invoiceTypeList.map((type) => (
                          <MenuItem key={type.toSend} value={type.toSend}>
                            {type.toShow}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item sm={12} xs={12}>
                    <FormControl required fullWidth={true} variant="outlined">
                      <InputLabel id="registerdisputes">
                        Select registered dispute
                      </InputLabel>
                      <Select
                        lableId="registerdisputes"
                        id="registered_disputes"
                        name="registered_disputes"
                        value={registeredDispute}
                        onChange={onRegisterDisputeChange}
                        label="Select registered dispute *"
                        IconComponent={() => (
                          <FontAwesomeIcon
                            icon={faChevronDown}
                            style={{ marginRight: "8px" }}
                          />
                        )}
                      >
                        {registeredDisputesList.map((dispute) => (
                          <MenuItem
                            key={dispute.id}
                            value={dispute.tiac_custom_dispute_id}
                          >
                            {`${
                              dispute.tiac_custom_dispute_id
                                ? dispute.tiac_custom_dispute_id
                                : ""
                            } - ${dispute.name}`}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item sm={12} xs={12}>
                    <FormControl required fullWidth={true} variant="outlined">
                      <InputLabel id="party">Select Party</InputLabel>
                      <Select
                        id="party"
                        name="party"
                        value={party}
                        onChange={onPartyChange}
                        label="Select Party *"
                        IconComponent={() =>
                          loading ? (
                            <CircularProgress
                              style={{
                                marginRight: "12px",
                                display: "flex",
                                color: "#2F80ED",
                              }}
                              size="2rem"
                            />
                          ) : (
                            <FontAwesomeIcon
                              icon={faChevronDown}
                              style={{ marginRight: "8px" }}
                            />
                          )
                        }
                      >
                        {partyList?.map((party, index) => (
                          <MenuItem key={index} value={party.id}>
                            {party.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item sm={5} xs={12}>
                    <FormControl required fullWidth={true} variant="outlined">
                      <InputLabel id="currency">Select currency</InputLabel>
                      <Select
                        id="currency"
                        name="currency"
                        value={currency}
                        onChange={onCurrencyChange}
                        label="Select currency *"
                        IconComponent={() => (
                          <FontAwesomeIcon
                            icon={faChevronDown}
                            style={{ marginRight: "8px" }}
                          />
                        )}
                      >
                        {currencyList.map((cur, index) => (
                          <MenuItem key={index} value={cur.toSend}>
                            {cur.toShow}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item sm={7} xs={12}>
                    <TextField
                      required
                      id="cost_amount"
                      name="cost_amount"
                      label="Enter cost amount"
                      variant="outlined"
                      fullWidth={true}
                      value={costAmount}
                      onChange={onCostAmountChange}
                      type="number"
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>

                  <Grid item sm={12} xs={12}>
                    <TextField
                      required
                      multiline={true}
                      rows={5}
                      id="description"
                      name="description"
                      label="Add Description"
                      variant="outlined"
                      fullWidth={true}
                      value={description}
                      onChange={onDescriptionChange}
                    />
                  </Grid>
                </Grid>
                <Box height="2rem"></Box>
                <Typography className={classes.helperText}>
                  The invoice (with bank details) will be emailed to the
                  selected party. Payment is to be made via bank transfer.
                </Typography>
                <Box height="1rem"></Box>
                <Button
                  variant="contained"
                  style={{
                    background: "#2F80ED",
                    color: "white",
                    textTransform: "none",
                  }}
                  onClick={onSubmit}
                  disabled={loading} // Disable when loading
                >
                  {loading ? <CircularProgress size={24} style={{ color: "white" }} /> : "Generate & Send Invoice"}
                </Button>
              </>
            )}
          </Paper>
        </Grid>
      </Grid>
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        autoHideDuration={5000}
        open={openSnackBar1}
        onClose={handleCloseSnackBar1}
        message={errorMessage}
      >
        <Alert onClose={handleCloseSnackBar1} severity="error">
          {errorMessage}
        </Alert>
      </Snackbar>
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        autoHideDuration={5000}
        open={openSnackBar2}
        onClose={handleCloseSnackBar2}
        message="Invoice generated successfully."
      >
        <Alert onClose={handleCloseSnackBar1} severity="success">
          Invoice generated successfully.
        </Alert>
      </Snackbar>
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        autoHideDuration={5000}
        open={openSnackBar3}
        onClose={handleCloseSnackBar3}
        message="Please enter all the mandatory details."
      >
        <Alert onClose={handleCloseSnackBar1} severity="warning">
          Please enter all the mandatory details.
        </Alert>
      </Snackbar>
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        autoHideDuration={5000}
        open={openSnackBar4}
        onClose={handleCloseSnackBar4}
        message="Please enter cost amount upto 2 decimal points."
      >
        <Alert onClose={handleCloseSnackBar1} severity="error">
          Please enter cost amount upto 2 decimal points.
        </Alert>
      </Snackbar>
    </div>
  );
};

async function sendInvoiceSebi(data) {
  return await instance.post("/surepay/send_payment_link/", data);
}

async function getDisputeDetails(id) {
  return await instance.get(`/api/tiacrvdisputedetailsbyid/${id}/`);
}

export default GenerateInvoice;
